import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import { FC, useEffect, useRef, useState } from "react";
import SurveyTab from "./SurveyTab";
import { useDispatch } from "react-redux";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import {
  getAllSurveyedItemsAction,
  setAllSurveyedItemsAction,
  setCancelSurveyAction,
  setIsGetSurveyedItemsAction,
  startSurveyAction,
  updateSurveyTabAction,
} from "../../../../store/reducers/leadSurveySlice";
import { useSelector } from "react-redux";
import useStyles from "./leadSurveyStyle";
import CustomButton from "../../../../components/common/button/CustomButton";
import NotesTab from "./NotesTab";
import SurveyedItemTab from "./SurveyedItemTab";
import SurveyedSummaryTab from "./SurveyedSummaryTab";
import ManageSurveyAppointment from "../../surveyDiary/ManageSurveyAppointment";
import { getSingleLeadAction } from "../../../../store/reducers/leadSlice";
import AlertCancelSurvey from "./AlertCancelSurvey";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import LeadDetailSection from "../estimate/LeadDetailSection";
import { getLeadColor } from "../../customerInvoice/InvoiceUntil";
import {
  getSingleSurveyAction,
  setUpdateSurveyDiaryResponse,
  updateSurveyDiaryAction,
} from "../../../../store/reducers/surveyDiarySlice";
import dayjs from "dayjs";
import AlertPopup from "../../../../components/common/alertPopup/AlertPopup";
import ManageNewSurveyAppointment from "../../surveyDiary/ManageNewSurveyAppointment";
import Notification from "../../../../components/common/notification/Notification";

// Define a type for the survey room structure
type SurveyRoom = {
  room: string;
  roomName?: string;
  isNew?: boolean;
  items?: any[];
  // Add other properties as needed
};

const LeadSurveyForm: FC<any> = ({ show, setShow, onGoToCustomer }) => {
  const [load, setLoad] = useState(false);
  const classes = useStyles({ show, load });
  const [value, setValue] = useState("0");
  const [prevTabValue, setPrevTabValue] = useState("0");
  const [subTabvalue, setSubTabValue] = useState(0);
  const [isSelfAssigned, setIsSelfAssigned] = useState(false);
  const [disabledAction, setDisabledAction] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<Date | null>(null); // State to store selected date
  const [surveyorType, setSurveyorType] = useState("");
  const [startNowClicked, setStartNowClicked] = useState(false);
  const [startNowConfirm, setStartNowConfirm] = useState(false);
  const [newAction, setNewAction] = useState("");
  //
  const [showQuoteWarning, setShowQuoteWarning] = useState(true);
  const [step, setStep] = useState<"warning" | "options">("warning");
  const [showNewSurveyModal, setShowNewSurveyModal] = useState(false);
  const [isReassignAction, setIsReassignAction] = useState(false);
  // Room list state lifted from SurveyTab
  const [localSurveyRoomList, setLocalSurveyRoomList] = useState<SurveyRoom[]>(
    [],
  );
  const { leadDetails } = useSelector((state: any) => state.lead);
  const {
    surveyRoomList,
    surveyedItems,
    isGetSurveyedItems,
    isCanceledSurvey,
  } = useSelector((state: any) => state.leadSurvey);
  // Merge surveyRoomList and surveyedItems into localSurveyRoomList
  useEffect(() => {
    if (!surveyRoomList?.length) return;

    let mergedRooms = surveyRoomList.map((room: any) => ({
      ...room,
      roomName: room?.roomName, // ensure roomName
    }));

    if (surveyedItems?.list?.length) {
      surveyedItems.list.forEach((item: any) => {
        const index = mergedRooms.findIndex(
          (room: any) => room.room === item.name,
        );

        if (index === -1) {
          mergedRooms.push({
            room: item.name,
            roomName: item?.roomName || item?.name, // fallback
            items: item.items || [],
          });
        } else {
          mergedRooms[index] = {
            ...mergedRooms[index],
            roomName:
              mergedRooms[index]?.roomName || item?.roomName || item?.name,
          };
        }
      });
    }

    setLocalSurveyRoomList(mergedRooms);
  }, [surveyRoomList, surveyedItems]);
  const { surveyDiaryDetail, isSurveyDiaryUpdateSuccess } = useSelector(
    (state: any) => state.surveyDiary,
  );
  const { user, userProfile, leadSurveyModulePermission } = useSelector(
    (state: any) => state.user,
  );

  const summaryTabRef = useRef<any>(null);
  const dispatch = useDispatch();

  const acceptedStatuses = ["JOB", "COMPLETE", "ARCHIVED", "LOST"];

  const editableStatuses = [
    "NEW LEAD",
    "ESTIMATE",
    "QUOTE",
    "SURVEY",
    "SURVEYED",
    "AWAITING",
    "PROVISIONAL",
    "CONFIRMED",
  ];

  const currentStatus = leadDetails?.lead?.status;

  const isAcceptedFlow = acceptedStatuses.includes(currentStatus);
  const isEditableFlow = editableStatuses.includes(currentStatus);

  useEffect(() => {
    if (surveyedItems) {
      if (surveyedItems?.status === "COMPLETED") {
        if (
          // userProfile?.staff_id?.indexOf("EMP") === 0 ||
          leadDetails?.lead?.status === "COMPLETED" ||
          leadDetails?.lead?.status === "DEBTOR" ||
          leadDetails?.lead?.status === "EXTERNAL"
        ) {
          setDisabledAction(true);
        } else if (user?.user?.roles[0]?.includes("CUSTOMER")) {
          setDisabledAction(true);
          // } else if(leadDetails?.isQuoteAccepted || leadDetails?.lead?.status==="QUOTE"){
          //   setDisabledAction(true);
        } else {
          setDisabledAction(false);
        }
      } else {
        if (
          surveyedItems?.surveyorId !== leadDetails?.lead?.customer_id &&
          surveyedItems?.surveyorId !== userProfile?.staff_id &&
          surveyedItems?.surveyorId !== user?.user?.id
        ) {
          setDisabledAction(true);
        } else {
          setDisabledAction(false);
        }
      }
    }
  }, [surveyedItems, userProfile]);

  useEffect(() => {
    if (leadDetails?.lead?.survey_id) {
      if (user?.user?.roles[0]?.includes("CUSTOMER")) {
        dispatch(
          getAllSurveyedItemsAction({
            surveyID: leadDetails?.lead?.survey_id,
            role: "customer",
          }),
        );
      } else {
        dispatch(getAllSurveyedItemsAction(leadDetails?.lead?.survey_id));
      }
    }
  }, [leadDetails?.lead?.survey_id]);

  useEffect(() => {
    if (isGetSurveyedItems) {
      if (user?.user?.roles[0]?.includes("CUSTOMER")) {
        dispatch(
          getAllSurveyedItemsAction({
            surveyID: leadDetails?.lead?.survey_id,
            role: "customer",
          }),
        );
      } else {
        dispatch(getAllSurveyedItemsAction(leadDetails?.lead?.survey_id));
      }
      dispatch(setIsGetSurveyedItemsAction(false));
    }
  }, [isGetSurveyedItems]);

  useEffect(() => {
    if (surveyedItems?.surveyorId === userProfile?.staff_id) {
      setIsSelfAssigned(true);
    } else {
      setIsSelfAssigned(false);
    }
  }, [surveyedItems, userProfile]);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setTimeout(() => {
      setLoad(true);
    }, 0);
    return () => {
      setLoad(false);
    };
  }, []);

  const contentRef = useRef<HTMLDivElement>(null); // Step 1: Initialize a ref

  const handleClose = () => {
    setOpenPopup(false);
    setShowNewSurveyModal(false);
    setSelectedSurvey("");
    setSelectedDate(null); // Reset selected date when closing
    if (leadDetails?.lead?.survey_id) {
      if (user?.user?.roles[0]?.includes("CUSTOMER")) {
        dispatch(
          getAllSurveyedItemsAction({
            surveyID: leadDetails?.lead?.survey_id,
            role: "customer",
          }),
        );
      } else {
        dispatch(getAllSurveyedItemsAction(leadDetails?.lead?.survey_id));
      }
    }
    dispatch(getSingleLeadAction(leadDetails?.lead?.generated_id));
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  const [cancelSurveyModel, setCancelSurveyModel] = useState(false);

  useEffect(() => {
    if (isCanceledSurvey) {
      setCancelSurveyModel(false);
      dispatch(setCancelSurveyAction(false));
      dispatch(setAllSurveyedItemsAction(null));
      handleClose();
      if (userProfile?.roles?.includes("Surveyor")) {
        setShow(false);
        dispatch(getSingleLeadAction(leadDetails?.lead?.generated_id));
      }
    }
  }, [isCanceledSurvey]);

  const closeModel = () => {
    setCancelSurveyModel(false);
  };

  const handleCancelSurvey = () => {
    setCancelSurveyModel(true);
  };

  const [surveyFirstTabForm, setSurveyFirstTabForm]: any = useState(null);
  const [isValueChanged, setIsValueChanged] = useState(false);
  const [surveyMaterialsPayload, setSurveyMaterialsPayload] = useState<any[]>(
    [],
  );
  const [isMaterialsChanged, setIsMaterialsChanged] = useState(false);

  const submitHandler = () => {
    const currentRoom = localSurveyRoomList?.[subTabvalue] || {};
    const activeTab = prevTabValue === "0" && value !== "0" ? "tab1" : "tab3";

    if (isValueChanged) {
      const surveyPayload = surveyFirstTabForm?.filter(
        (item: any) => item?.item,
      );
      dispatch(
        updateSurveyTabAction({
          tab: activeTab,
          surveyId: leadDetails?.lead?.survey_id,
          data: {
            name: currentRoom.room || "",
            roomName: currentRoom.roomName || "",
            isNew: false,
            items: surveyPayload,
          },
        }),
      );
      setIsValueChanged(false);
    }

    if (isMaterialsChanged) {
      const materialPayload = (surveyMaterialsPayload || [])
        .filter((item: any) => item?.item)
        .map((item: any) => ({ ...item }));

      dispatch(
        updateSurveyTabAction({
          tab: activeTab,
          surveyId: leadDetails?.lead?.survey_id,
          data: {
            name: "Materials",
            roomName: "Materials",
            isNew: false,
            items: materialPayload,
          },
        }),
      );
      setIsMaterialsChanged(false);
    }
  };

  useEffect(() => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    if (prevTabValue === "0" && value !== "0") {
      submitHandler();
    } else if (prevTabValue === "2" && value !== "2") {
      submitHandler();
    } else {
    }
    setPrevTabValue(value); // Update previous tab value after handling
  }, [value]);

  useEffect(() => {
    if (selectedSurvey) {
      dispatch(getSingleSurveyAction(selectedSurvey));
    }
  }, [selectedSurvey]);

  useEffect(() => {
    if (surveyDiaryDetail && startNowClicked) {
      startNowSurvey();
    }
  }, [surveyDiaryDetail]);

  const startNowSurvey = () => {
    const addresses = leadDetails.lead.collection_address || [];

    const formattedAddresses = addresses
      .map((addr: any, index: number) => {
        const street = addr?.street || "";
        const town = addr?.town || "";
        const country = addr?.country || "";
        const postcode = addr?.postcode || "";

        return `\nAddress ${
          index + 1
        } : ${street}, ${town}, ${country}, ${postcode}`;
      })
      .join("\n");

    const description = `Client Email : ${
      leadDetails.lead.customer_email
    }\nMobile : ${leadDetails?.lead?.countryCode}${leadDetails?.lead?.customer_phone || ""}${formattedAddresses}`;
    const startTime = dayjs();
    const endTime = startTime.add(60, "minute"); // Add 30 minutes to start time
    const surveyDetail = {
      customer_name: leadDetails.lead.customer_name,
      leadId: leadDetails.lead.generated_id,
      surveyType: surveyDiaryDetail?.survey_type,
      description,
      surveyDate: dayjs().format("YYYY-MM-DD"),
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
      surveyorId: userProfile?.staff_id,
    };
    dispatch(updateSurveyDiaryAction({ ...surveyDetail, id: selectedSurvey }));
  };

  useEffect(() => {
    if (isSurveyDiaryUpdateSuccess && startNowClicked) {
      dispatch(startSurveyAction(leadDetails?.lead?.survey_id));
      dispatch(setUpdateSurveyDiaryResponse(false));
      setStartNowClicked(false);
      setNewAction("");
      setShowQuoteWarning(false);
    } else {
      setStartNowClicked(false);
    }
  }, [isSurveyDiaryUpdateSuccess]);

  return (
    <>
      {cancelSurveyModel && (
        <AlertCancelSurvey
          open={cancelSurveyModel}
          onHide={closeModel}
          alertModalShow={cancelSurveyModel}
          setAlertModelShow={setCancelSurveyModel}
        />
      )}
      {openPopup && (
        <ManageSurveyAppointment
          selectedSurvey={selectedSurvey}
          selectedDate={selectedDate} // Pass the selected date to the modal
          open={openPopup}
          selectedResource={""}
          onHide={handleClose}
          title="Enter Survey Details"
          surveyorType={surveyorType}
          tabValue={"1"}
          isReassignAction={isReassignAction}
          onGoToCustomer={() => {}}
        />
      )}

      <div
        id="estimate-popup-fixed"
        className={classes.estimatePopupContainer}
        style={{
          zIndex: show ? 11 : -1,
        }}
      >
        <Grid container spacing={2} ref={contentRef}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ height: "45px", zIndex: 99, paddingLeft: "0px" }}
          >
            <div className={classes.popupTitle}>
              <Box
                sx={{
                  display: "inline-block",
                  px: 3,
                  py: 1,
                  backgroundColor: getLeadColor("SURVEY"),
                  color: "white",
                  clipPath:
                    "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)",
                }}
              >
                <Typography
                  sx={{ fontSize: "14px", marginLeft: "2px" }}
                  variant="subtitle1"
                >
                  Survey
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  color: getLeadColor("SURVEY"),
                }}
                variant="subtitle1"
              >
                Survey
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {/* ✅ Go to Customer button */}
                {onGoToCustomer && leadDetails?.lead?.generated_id && (
                  <CustomButton
                    style={{
                      marginRight: 10,
                      padding: "4px 14px",
                      height: "32px",
                      fontSize: 13,
                    }}
                    variant="outlined"
                    title="Go to Customer"
                    onClick={() =>
                      onGoToCustomer(leadDetails.lead.generated_id)
                    }
                  />
                )}
                {value === "3" && !disabledAction && (
                  <img
                    onClick={() => summaryTabRef.current?.save()}
                    src={checkedIcon}
                    style={{
                      cursor: "pointer",
                      height: "26px",
                      width: "26px",
                      marginRight: 10,
                      display:
                        leadDetails?.lead?.status === "COMPLETED"
                          ? "none"
                          : "block",
                    }}
                    alt="save"
                  />
                )}
                <img
                  src={closeIcon}
                  style={{ cursor: "pointer", height: "26px", width: "26px" }}
                  onClick={() => {
                    setShow(false);
                    dispatch(setAllSurveyedItemsAction(null));
                    dispatch(
                      setNotificationAction({ message: [], severity: "error" }),
                    );
                  }}
                  alt="cross-icon"
                />
              </Box>
            </div>
          </Grid>
          {surveyedItems ? (
            <Grid
              item
              xs={12}
              sm={12}
              sx={{
                opacity: load ? 1 : 0,
                paddingLeft: "0px !important",
              }}
            >
              {surveyedItems?.status === "PENDING" ? (
                <div
                  style={{
                    textAlign: "center",
                    fontSize: "14px",
                  }}
                >
                  {isSelfAssigned ? (
                    <>
                      <CustomButton
                        title="Start Survey"
                        onClick={() => {
                          dispatch(
                            startSurveyAction(leadDetails?.lead?.survey_id),
                          );
                        }}
                      />
                      {!userProfile?.roles.includes("Surveyor") && (
                        <>
                          <CustomButton
                            style={{ marginLeft: "16px" }}
                            title="Reassign Surveyor"
                            onClick={() => {
                              // navigator('/survey-diary');
                              setOpenPopup(true);
                              setSelectedDate(new Date());
                              setSurveyorType("");
                              setSelectedSurvey(leadDetails?.lead?.survey_id);
                              setIsReassignAction(true);
                            }}
                          />
                        </>
                      )}
                      <CustomButton
                        disabled={
                          !(
                            user?.user?.roles?.includes("Owner") ||
                            user?.user?.roles?.includes("TENANT") ||
                            leadSurveyModulePermission?.create
                          )
                        }
                        style={{ marginLeft: "16px" }}
                        title="Cancel Survey"
                        onClick={() => {
                          handleCancelSurvey();
                        }}
                      />
                    </>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        width: "100%",
                        padding: "25px 0 0 0",
                        color: "#eb7c16",
                      }}
                    >
                      <p>
                        Please wait till the survey starts. <br />
                        <br />
                        Once Survey is started then you can see the detail.{" "}
                        <br />
                        <br />
                        The survey is not scheduled to start yet
                        <br />
                        {!userProfile?.roles.includes("Surveyor") && (
                          <>
                            OR
                            <br />
                            <br />
                            <CustomButton
                              title="Start the survey now"
                              onClick={() => {
                                setStartNowConfirm(true);
                              }}
                            />{" "}
                            &nbsp;
                          </>
                        )}
                        <br />
                        <br />
                        OR
                        <br />
                        <br />
                        <CustomButton
                          title="Reassign Surveyor"
                          onClick={() => {
                            // navigator('/survey-diary');
                            setOpenPopup(true);
                            setSelectedDate(new Date());
                            setSurveyorType("");
                            setSelectedSurvey(leadDetails?.lead?.survey_id);
                            setIsReassignAction(true);
                          }}
                        />
                        <br />
                        <br />
                        OR
                        <br />
                        <br />
                        <CustomButton
                          title="Free Surveyor"
                          onClick={() => {
                            handleCancelSurvey();
                          }}
                        />
                      </p>
                    </div>
                  )}
                </div>
              ) : (leadDetails?.lead?.status === "QUOTE" ||
                  leadDetails?.lead?.status === "CONFIRMED" ||
                  leadDetails?.lead?.status === "AWAITING" ||
                  leadDetails?.lead?.status === "PROVISIONAL") &&
                showQuoteWarning &&
                !user?.user?.roles[0]?.includes("CUSTOMER") ? (
                <>
                  {/* CASE 1 - Quote already accepted */}
                  {isAcceptedFlow && (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        width: "100%",
                        padding: "25px 0 0 0",
                        color: "#eb7c16",
                      }}
                    >
                      <p>
                        This survey has already been quoted and accepted.
                        <br />
                        You must cancel the existing acceptance before you can
                        continue
                      </p>
                      <br />
                      <br />
                      <CustomButton
                        title="OK"
                        onClick={() => setShowQuoteWarning(false)}
                      />
                    </div>
                  )}

                  {/* CASE 2 - Quote exists but NOT accepted */}
                  {isEditableFlow && step === "warning" && (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        width: "100%",
                        padding: "25px 0 0 0",
                        color: "#eb7c16",
                      }}
                    >
                      <p>
                        {/* This survey has already been quoted and cannot be
                        amended */}
                        All the quotes generated will me marked DECLINED
                      </p>
                      <br />
                      <br />

                      <CustomButton
                        title="Create a new survey"
                        onClick={() => setStep("options")}
                      />

                      <br />
                      <br />

                      <CustomButton
                        variant="outlined"
                        title="Cancel"
                        onClick={() => setShowQuoteWarning(false)}
                      />
                    </div>
                  )}

                  {/* CASE 3 - New Survey Options */}
                  {isEditableFlow && step === "options" && (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "16px",
                        width: "100%",
                        padding: "25px 0 0 0",
                        color: "#eb7c16",
                      }}
                    >
                      <p>Select how you want to create the new survey</p>

                      <br />
                      <br />
                      <CustomButton
                        title="Copy the existing survey"
                        onClick={() => {
                          setShowNewSurveyModal(true);
                          setSelectedDate(new Date());
                          setSurveyorType("");
                          setSelectedSurvey(leadDetails?.lead?.survey_id);
                          setNewAction("isCopy");
                        }}
                      />

                      <br />
                      <br />

                      <CustomButton
                        title="Start from scratch"
                        onClick={() => {
                          setShowNewSurveyModal(true);
                          setSelectedDate(new Date());
                          setSurveyorType("");
                          setSelectedSurvey(leadDetails?.lead?.survey_id);
                          setNewAction("isCreate");
                        }}
                      />

                      <br />
                      <br />

                      <CustomButton
                        variant="outlined"
                        title="Cancel"
                        onClick={() => setShowQuoteWarning(false)}
                      />
                    </div>
                  )}
                </>
              ) : (
                <>
                  <Grid container spacing={0.5} sx={{ fontSize: "14px" }}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      sx={{
                        paddingLeft: "0px !important",
                        paddingTop: "0px !important",
                      }}
                    >
                      <LeadDetailSection leadDetails={leadDetails} />
                      <Notification />
                    </Grid>
                  </Grid>
                  <Box
                    sx={{
                      marginBottom: "16px",
                      border: "1px solid #CFCFCF",
                      borderRadius: "5px",
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        padding: "10px",
                        borderBottom: "1px solid #CFCFCF",
                      }}
                    >
                      Assigned surveyor:{" "}
                      <strong>
                        {isSelfAssigned
                          ? "Self"
                          : surveyedItems?.surveyorName || "Not Assigned"}
                      </strong>
                      <span style={{ margin: "0 7px" }}>|</span>
                      Status:{" "}
                      <strong
                        className={
                          surveyedItems?.status === "PENDING"
                            ? "survey-pending"
                            : surveyedItems?.status === "STARTED" ||
                                surveyedItems?.status === "IN PROGRESS"
                              ? "survey-inprogress"
                              : surveyedItems?.status === "COMPLETED"
                                ? "survey-completed"
                                : "survey-pending"
                        }
                      >
                        {surveyedItems?.status || "PENDING"}
                      </strong>
                    </div>
                    <Tabs
                      centered
                      value={value}
                      onChange={handleChange}
                      textColor="secondary"
                      indicatorColor="secondary"
                      aria-label="secondary tabs example"
                      variant="standard"
                      sx={{
                        background: "#fff",
                        fontSize: "14px",
                        fontWeight: 600,
                      }}
                    >
                      <Tab value="0" label="Survey" />
                      {/* <Tab value="1" label="Notes" /> */}
                      <Tab value="2" label="Surveyed Item" />
                      <Tab value="3" label="Summary" />
                    </Tabs>
                  </Box>
                  {value === "0" && (
                    <SurveyTab
                      contentRef={contentRef}
                      disabledAction={disabledAction}
                      subTabvalue={subTabvalue}
                      setSubTabValue={setSubTabValue}
                      setSurveyFirstTabForm={setSurveyFirstTabForm}
                      isValueChanged={isValueChanged}
                      setIsValueChanged={setIsValueChanged}
                      localSurveyRoomList={localSurveyRoomList}
                      setLocalSurveyRoomList={setLocalSurveyRoomList}
                      setSurveyMaterialsPayload={setSurveyMaterialsPayload}
                      isMaterialsChanged={isMaterialsChanged}
                      setIsMaterialsChanged={setIsMaterialsChanged}
                    />
                  )}
                  {value === "1" && (
                    <NotesTab disabledAction={disabledAction} />
                  )}
                  {value === "2" && (
                    <SurveyedItemTab
                      contentRef={contentRef}
                      disabledAction={disabledAction}
                      subTabvalue={subTabvalue}
                      setSubTabValue={setSubTabValue}
                      setSurveyFirstTabForm={setSurveyFirstTabForm}
                      isValueChanged={isValueChanged}
                      setIsValueChanged={setIsValueChanged}
                    />
                  )}
                  {value === "3" && (
                    <SurveyedSummaryTab
                      ref={summaryTabRef}
                      show={show}
                      setShow={setShow}
                      disabledAction={disabledAction}
                    />
                  )}
                </>
              )}
            </Grid>
          ) : (
            !leadDetails?.lead?.survey_id && (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  width: "100%",
                  padding: "25px 0 0 0",
                }}
              >
                <div>
                  <p>Survey is not scheduled yet.</p>
                  <br />
                  <CustomButton
                    title="Assign to Self"
                    onClick={() => {
                      setOpenPopup(true);
                      setSelectedDate(new Date());
                      setSurveyorType("self");
                    }}
                  />{" "}
                  &nbsp;
                  <CustomButton
                    title="Assign Surveyor"
                    onClick={() => {
                      // navigator('/survey-diary');
                      setOpenPopup(true);
                      setSelectedDate(new Date());
                      setSurveyorType("surveyor");
                    }}
                  />
                </div>
              </div>
            )
          )}
        </Grid>
      </div>
      {startNowConfirm && (
        <>
          <AlertPopup
            open={startNowConfirm}
            title="Alert"
            content={` If you start this survey now, it will be assigned to you. Do you want to continue?`}
            onHide={() => setStartNowConfirm(false)}
            submitHandler={() => {
              setStartNowConfirm(false);

              setSelectedDate(new Date());
              setSurveyorType("self");
              setSelectedSurvey(leadDetails?.lead?.survey_id);
              setStartNowClicked(true);
            }}
          />
        </>
      )}
      {/* New Survey Modal */}
      {showNewSurveyModal && (
        <ManageNewSurveyAppointment
          selectedSurvey={selectedSurvey}
          selectedDate={selectedDate} // Pass the selected date to the modal
          open={showNewSurveyModal}
          selectedResource={""}
          onHide={handleClose}
          title="Enter Survey Details"
          surveyorType={surveyorType}
          action={newAction}
          tabValue={"1"}
        />
      )}
    </>
  );
};

export default LeadSurveyForm;
